import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  mapButton: {
    borderRadius: '4px',
    border: '1px solid #DCDCE4',
    color: '#2F80ED',
    fontSize: '12px',
    fontWeight: 600
  },
  ignoreButton: {
    borderRadius: '4px',
    border: '1px solid #DCDCE4',
    color: '#EB5757',
    fontSize: '12px',
    fontWeight: 600
  },
  editIcon: {
    borderRadius: '6px',
    marginRight: '8px',
    padding: '4px',
    backgroundColor: '#E9EDF5'
  },
}));

export default useStyles;
